import { JsonViewer } from '@textea/json-viewer';
import { ContentHeader } from '@app/shared';
import { ScrollableContentContainer } from '../components/ScrollableContentContainer';
import { ComponentErrorBoundary } from '@app/utilities';
import { Schema } from '@app/models';

export function RuleDefinitionDetail({ schema }: { schema: Schema }) {
  return (
    <ComponentErrorBoundary>
      <ContentHeader style={{ borderBottom: 'thin solid lightgrey', paddingBottom: '10px' }}>Schema</ContentHeader>
      <ScrollableContentContainer height={'calc(100% - 50px)'}>
        <div className={'json-view'}>{!schema ? <div>Loading...</div> : <JsonViewer value={schema} />}</div>
      </ScrollableContentContainer>
    </ComponentErrorBoundary>
  );
}
